import { render, staticRenderFns } from "./WorksShow.vue?vue&type=template&id=360e684e&scoped=true"
import script from "./WorksShow.vue?vue&type=script&lang=js"
export * from "./WorksShow.vue?vue&type=script&lang=js"
import style0 from "./WorksShow.vue?vue&type=style&index=0&id=360e684e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e684e",
  null
  
)

export default component.exports